module.exports = __webpack_public_path__ + "static/media/img179.73c3f2e7.jpg";